// External Link Constants
import {
  THRONE_URL,
  CASH_APP_URL,
  APPLE_PAY_EMAIL,
  VENMO_URL,
  PAYPAL_URL,
  WISHLIST_URL,
  ONLYFANS_URL,
  TWITTER_URL,
  SNAPCHAT_URL,
  LOYALFANS_URL,
  TIKTOK_URL,
  YOUPAY_URL,
  SCATBOOK_URL,
  FANSLY_URL,
  FETLIFE_URL,
  TELEGRAM_URL,
  LOVERFANS_NANNYM_URL,
  THRONE_NANNYM_URL,
  KO_FI_URL,
} from '../../utils/Constants';
// Icons
import {
  FaPaypal,
  FaTwitter,
  FaSnapchat,
  FaAmazon,
  FaApple,
  FaTiktok,
  FaTelegramPlane,
} from 'react-icons/fa';
import { SiVenmo, SiCashapp, SiOnlyfans } from 'react-icons/si';
import { GiStoneThrone } from 'react-icons/gi';
import { MdPayments } from 'react-icons/md';
import { RiScales3Fill } from 'react-icons/ri';
import { FaFan } from 'react-icons/fa6';
import FetlifeIcon from '../../assets/images/icons/fetfile-icon-no-background.svg';
import KissIcon from '../../assets/images/icons/kiss-svgrepo-com.svg';
import { FaMoneyBill } from "react-icons/fa";

export const linkButtonArray = [
  { text: 'Throne Wishlist', link: THRONE_URL, icon: <GiStoneThrone /> },
  { text: 'NannyM Throne', link: THRONE_NANNYM_URL, icon: <GiStoneThrone /> },
  { text: 'PayPal', link: PAYPAL_URL, icon: <FaPaypal /> },
  { text: 'LoyalFans', link: LOYALFANS_URL, icon: <img src={KissIcon} alt="LoverFans" className="w-6 h-6" /> }, // UPDATED
  { text: 'NannyM LoverFans', link: LOVERFANS_NANNYM_URL, icon: <FaMoneyBill /> },
  { text: 'OnlyFans', link: ONLYFANS_URL, icon: <SiOnlyfans /> },
  { text: 'Fansly', link: FANSLY_URL, icon: <FaFan /> },
  { text: 'Fetlife', link: FETLIFE_URL, icon: <img src={FetlifeIcon} alt="Fetlife" className="w-6 h-6" /> }, // UPDATED
  { text: 'Cash App', link: CASH_APP_URL, icon: <SiCashapp /> },
  { text: 'Apple Pay', link: APPLE_PAY_EMAIL, icon: <FaApple /> },
  { text: 'Venmo', link: VENMO_URL, icon: <SiVenmo /> },
  { text: 'Amazon Wishlist', link: WISHLIST_URL, icon: <FaAmazon /> },
  { text: 'Twitter', link: TWITTER_URL, icon: <FaTwitter /> },
  { text: 'Snapchat', link: SNAPCHAT_URL, icon: <FaSnapchat /> },
  { text: 'TikTok', link: TIKTOK_URL, icon: <FaTiktok /> },
  { text: 'YouPay', link: YOUPAY_URL, icon: <MdPayments /> },
  { text: 'Scatbook', link: SCATBOOK_URL, icon: <RiScales3Fill /> },
  { text: 'Telegram', link: TELEGRAM_URL, icon: <FaTelegramPlane /> },
  { text: 'Ko-fi', link: KO_FI_URL, icon: <FaPaypal /> },
];

